var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#f9f9f9;}.cls-3{isolation:isolate;}.cls-4{mix-blend-mode:multiply;opacity:.15;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.32,
    y1: 6.63,
    x2: 8.63,
    y2: 6.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.41,2.44c-1.99,0-3.53,1.61-3.53,3.71s1.41,3.55,3.51,3.55c1.49,0,2.38-.55,3.17-1.7l-1.23-.83c-.45,.66-.91,1.03-1.81,1.03-.99,0-1.61-.71-1.74-1.66h4.88c.05-.28,.09-.61,.09-.88,0-1.85-1.43-3.21-3.35-3.21Zm-1.53,2.81c.2-.78,.69-1.35,1.58-1.35,.77,0,1.35,.51,1.39,1.35h-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.15,2.44c-.67,0-1.54,.24-2.05,.88V.4h-1.88V9.54h1.88v-.69c.52,.63,1.36,.84,2.03,.84,1.87,0,3.25-1.65,3.25-3.6s-1.39-3.66-3.23-3.66Zm-.44,5.65c-.59,0-1.15-.2-1.61-.75v-2.37c.41-.69,1.04-.92,1.64-.92,1.08,0,1.73,.96,1.73,1.99s-.55,2.05-1.76,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.17,7.91c-.24,.12-.46,.2-.75,.2-.4,0-.55-.25-.61-.66-.02-.18-.03-.34-.03-.52v-2.76h1.77v-1.56h-1.77V.4h-1.88V2.6h-.83v1.56h.83v3h0c0,.37,.03,.74,.13,1.05,.25,.9,.98,1.49,2.06,1.49,.54,0,1.2-.15,1.65-.41l-.58-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.43,.33C1.86,.6,0,2.92,.28,5.49c.28,2.57,2.59,4.44,5.16,4.16,.71-.08,1.36-.31,1.93-.66l-1.34-1.34c-.24,.1-.51,.17-.78,.2-1.57,.17-2.99-.98-3.16-2.56-.17-1.58,.97-3,2.54-3.17s2.99,.98,3.16,2.56c.05,.46-.01,.91-.17,1.32l-2.3-2.3v2.54l3.31,3.31v-1.71c.71-.92,1.08-2.11,.95-3.36C9.3,1.92,6.99,.05,4.43,.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.32 3.7 5.32 6.24 8.63 9.56 5.32 3.7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo_2.11418ff9da44920cd4bc6aa7c9e976da.svg";
export { ForwardRef as ReactComponent };